<section>
    <div class="container">
        <div class="contents">
            <div class="header-container">
                <h2 class="header" *ngIf="pageData.headerContent">{{ pageData.headerContent }}</h2>
                <h4 class="bill-amount" *ngIf="pageData.billChangeAmount">{{ pageData.billChangeAmount }}</h4>
            </div>
            <h3 class="sub-header" *ngIf="pageData.subheaderContent">{{ pageData.subheaderContent }}</h3>
        </div>
        <div class="lines-afffected-list" *ngFor="let data of pageData.linesAffected">
            <p>{{ data.header }}</p>
            <h4>{{ data.body }}</h4>
        </div>
        <div class="downgrade-section" *ngIf="pageData?.downgrade">
            <div class= "header-container">
                <h4 class="downgrade-header">{{ pageData.downgrade.header }}</h4><div class="badge">{{ pageData.downgrade.badge }}</div>
            </div>
            <p class="downgrade-subheader">{{ pageData.downgrade.body }}</p>
        </div>
    </div>
</section>
